export const REFERRER = 'x-dr-referrer';
export const X_DR_DEALERID = 'x-dr-dealerid';
export const X_DR_DEALER_COMMON_ORG_ID = 'x-dr-dealer-common-org-id';
export const TOGGLE_OVERRIDE = 'x-dr-toggle-override';
export const TRACE_ID_HEADER = 'x-dr-trace-id';
export const SESSION_ID_HEADER = 'x-dr-session-id';
export const X_CLEAR_DEAL_REFID = 'x-clear-deal-refid';
export const X_DR_TESTING_REQUEST = 'x-dr-testing-request';
export const COX_AUTO_CORRELATION_ID_HEADER = 'X-CoxAuto-Correlation-Id';
export const ROLE_ASSUMPTION_USER_NAME_HEADER = 'x-dr-role-assumption-user-name';
export const X_DR_DEALER_ID = 'x-dr-dealer-id';
export const X_DR_DEALXGID = 'x-dr-dealxgid';

export const ORIGIN = 'origin';
export const REFERER = 'referer';
export const PARTY_ID = 'partyId';
export const COMMON_ORG_ID = 'commonOrgid';
export const FINANCE_METHOD = 'financeMethod';
export const FORM_CONTRACT_TYPE_HEADER = 'form-contract-type';
export const DEAL_XG_DEAL_ID = 'DealXgDealId';
export const IS_DRAFT_HEADER = 'isDraft';
export const LENDER_ID_HEADER = 'lenderId';
export const DEALER_ID_HEADER = 'DealerId';
export const PLATFORM_USER_ID = 'platformuserid';
export const SOURCE_PARTNER_ID = 'sourcePartnerId';
export const TARGET_PLATFORM_ID = 'targetPlatformId';
export const COMMON_CONSUMER_ID = 'commonconsumerid';
export const DEALER_NAME_HEADER = 'DealerName';
export const CONTENT_TYPE_HEADER = 'Content-Type';
export const IS_TEST_DEALER_HEADER = 'IsTestDealer';
export const DEAL_XG_DEAL_VERSION = 'DealXgDealVersion';
